import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function CourseViewLayer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [chapters, setChapters] = useState([]);
  const courseToView = location.state?.course;

  useEffect(() => {
    fetchCourseDataWithChapterAndUnit();
  }, [courseToView]);

  const fetchCourseDataWithChapterAndUnit = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/getCourseDatawithChapterAndUnit/${courseToView._id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setChapters(response.data.data);
        // console.log(response.data.data);
      } catch (error) {
        // console.log(error);
      }
    };

  // Sample data - replace with your actual data
  // const chapters = [
  //   {
  //     id: 1,
  //     title: "Chapter 1: Introduction",
  //     units: [
  //       { id: 1, title: "Unit 1.1: Getting Started" },
  //       { id: 2, title: "Unit 1.2: Basic Concepts" },
  //     ],
  //   },
  //   {
  //     id: 2,
  //     title: "Chapter 2: Advanced Topics",
  //     units: [
  //       { id: 3, title: "Unit 2.1: Advanced Features" },
  //       { id: 4, title: "Unit 2.2: Implementation" },
  //     ],
  //   },
  // ];

  const handleUnitClick = (unitId) => {
    // console.log("unit_id: ", unitId);
    
    navigate(`/unit-view/${unitId}`);
  };

  return (
    <div>
      {/* <div className="card-header border-bottom bg-base py-16 px-24 mb-5"> */}
        {/* <h1 className="text-center mb-0">Course View</h1> */}
      {/* </div> */}

      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          {chapters?.map((chapter) => (
            <div key={chapter?._id} className="card mb-3 radius-12">
              <div className="card-header bg-base border-bottom py-16 px-24">
                <h4 className="mb-0">{chapter.title}</h4>
              </div>
              <div className="card-body p-0">
                {chapter?.units?.map((unit) => (
                  <div
                    key={unit?.id}
                    className="unit-item px-24 py-16 border-bottom cursor-pointer hover-bg-neutral-100"
                    onClick={() => handleUnitClick(unit.id)}
                    style={{
                      padding: "15px",
                      borderBottom: "1px solid #eee",
                      cursor: "pointer",
                      transition: "background-color 0.2s",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#334057")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    {unit.title}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CourseViewLayer;
